"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSummarySegment = exports.ReportSegment = exports.ReportFilterKey = exports.ColumnSize = exports.ColumnType = exports.FilterOperator = exports.DateRangeGranularity = exports.ReportTypes = exports.WidgetChartType = exports.DateRangeFilterPresets = exports.DateRangeFilterType = void 0;
var DateRangeFilterType;
(function (DateRangeFilterType) {
    DateRangeFilterType["FILTER_BY_PRESET"] = "FILTER_BY_PRESET";
    DateRangeFilterType["CUSTOM_DATES"] = "CUSTOM_DATES";
    DateRangeFilterType["FILTER_BY_TIME"] = "FILTER_BY_TIME";
    DateRangeFilterType["FILTER_BY_TRADING_PERIOD"] = "FILTER_BY_TRADING_PERIOD";
})(DateRangeFilterType = exports.DateRangeFilterType || (exports.DateRangeFilterType = {}));
var DateRangeFilterPresets;
(function (DateRangeFilterPresets) {
    DateRangeFilterPresets["TODAY"] = "TODAY";
    DateRangeFilterPresets["YESTERDAY"] = "YESTERDAY";
    DateRangeFilterPresets["THIS_WEEK"] = "THIS_WEEK";
    DateRangeFilterPresets["THIS_MONTH"] = "THIS_MONTH";
    DateRangeFilterPresets["THIS_QUARTER"] = "THIS_QUARTER";
    DateRangeFilterPresets["THIS_YEAR"] = "THIS_YEAR";
    DateRangeFilterPresets["LAST_7_DAYS"] = "LAST_7_DAYS";
    DateRangeFilterPresets["LAST_30_DAYS"] = "LAST_30_DAYS";
    DateRangeFilterPresets["LAST_WEEK"] = "LAST_WEEK";
    DateRangeFilterPresets["LAST_MONTH"] = "LAST_MONTH";
    DateRangeFilterPresets["LAST_QUARTER"] = "LAST_QUARTER";
    DateRangeFilterPresets["LAST_YEAR"] = "LAST_YEAR";
})(DateRangeFilterPresets = exports.DateRangeFilterPresets || (exports.DateRangeFilterPresets = {}));
var WidgetChartType;
(function (WidgetChartType) {
    WidgetChartType["TABLE"] = "table";
    WidgetChartType["LINE"] = "line";
    WidgetChartType["PIE"] = "pie";
    WidgetChartType["BAR"] = "bar";
    WidgetChartType["METRIC"] = "metric";
    WidgetChartType["CARD"] = "card";
})(WidgetChartType = exports.WidgetChartType || (exports.WidgetChartType = {}));
var ReportTypes;
(function (ReportTypes) {
    ReportTypes["DAILY_SALES_SUMMARY"] = "DAILY_SALES_SUMMARY";
})(ReportTypes = exports.ReportTypes || (exports.ReportTypes = {}));
var DateRangeGranularity;
(function (DateRangeGranularity) {
    DateRangeGranularity["SECOND"] = "second";
    DateRangeGranularity["MINUTE"] = "minute";
    DateRangeGranularity["HOUR"] = "hour";
    DateRangeGranularity["DAY"] = "day";
    DateRangeGranularity["WEEK"] = "week";
    DateRangeGranularity["MONTH"] = "month";
})(DateRangeGranularity = exports.DateRangeGranularity || (exports.DateRangeGranularity = {}));
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["EQUALS"] = "equals";
    FilterOperator["NOT_EQUALS"] = "notEquals";
    FilterOperator["CONTAINS"] = "contains";
    FilterOperator["NOT_CONTAINS"] = "notContains";
    FilterOperator["GREATER_THAN"] = "gt";
    FilterOperator["GREATER_THEN_EQUAL"] = "gte";
    FilterOperator["LESS_THAN"] = "lt";
    FilterOperator["LESS_THAN_EQUAL"] = "lte";
})(FilterOperator = exports.FilterOperator || (exports.FilterOperator = {}));
var ColumnType;
(function (ColumnType) {
    ColumnType["NUMBER"] = "number";
    ColumnType["MONEY"] = "money";
    ColumnType["DATE"] = "date";
    ColumnType["TIME"] = "time";
    ColumnType["PERCENT"] = "percent";
    ColumnType["EXPORT"] = "export";
    ColumnType["STRING"] = "string";
    ColumnType["ENUM"] = "enum";
    ColumnType["PREVIEW"] = "preview";
    ColumnType["MONEY_ROUND_DOWN"] = "money_round_down";
})(ColumnType = exports.ColumnType || (exports.ColumnType = {}));
var ColumnSize;
(function (ColumnSize) {
    ColumnSize["SMALL"] = "small";
    ColumnSize["OPTION"] = "option";
    ColumnSize["REGULAR"] = "regular";
})(ColumnSize = exports.ColumnSize || (exports.ColumnSize = {}));
var ReportFilterKey;
(function (ReportFilterKey) {
    ReportFilterKey["VENUES"] = "venues";
    ReportFilterKey["STORES"] = "stores";
    ReportFilterKey["DEVICES"] = "devices";
    ReportFilterKey["SALES_CHANNELS"] = "salesChannels";
    ReportFilterKey["PAYMENT_TYPES"] = "paymentTypes";
    ReportFilterKey["ORDER_TYPES"] = "orderTypes";
    ReportFilterKey["STAFF"] = "staff";
    ReportFilterKey["REFUND_REASONS"] = "refundReasons";
})(ReportFilterKey = exports.ReportFilterKey || (exports.ReportFilterKey = {}));
var ReportSegment;
(function (ReportSegment) {
    ReportSegment["ORDER_COMPLETED"] = "Orders.completedOrders";
    ReportSegment["ORDER_VOID"] = "Orders.voidOrders";
    ReportSegment["ORDER_ITEM_COMPLETED"] = "OrderItems.completedItems";
    ReportSegment["ORDER_ITEM_VOID"] = "OrderItems.voidItems";
    ReportSegment["ORDER_REFUNDED"] = "Orders.refundedOrders";
    ReportSegment["NON_VOIDED_ORDERS"] = "Orders.nonVoidedOrders";
    ReportSegment["NON_VOIDED_ITEMS"] = "OrderItems.nonVoidedItems";
    ReportSegment["GROUP_BY_DAY"] = "Orders.updatedAt.day";
    ReportSegment["GROUP_BY_WEEK"] = "Orders.updatedAt.week";
    ReportSegment["GROUP_BY_MONTH"] = "Orders.updatedAt.month";
    ReportSegment["PRODUCTS_ONLY"] = "OrderItems.productsOnly";
})(ReportSegment = exports.ReportSegment || (exports.ReportSegment = {}));
var PaymentSummarySegment;
(function (PaymentSummarySegment) {
    PaymentSummarySegment["PAYMENT_METHOD_NAME"] = "OrderPayments.paymentTypeName";
    PaymentSummarySegment["CARD_TYPE"] = "OrderPayments.cardType";
})(PaymentSummarySegment = exports.PaymentSummarySegment || (exports.PaymentSummarySegment = {}));
//# sourceMappingURL=reporting.js.map